import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import type { ConversationalDynamics } from '../types';
import SectionShell, { Figure, formatSeconds } from './SectionShell';

/** Who did the talking, and how: share of voice, interruptions, monologues. */
const ConversationalDynamicsSection: React.FC<{ data?: ConversationalDynamics }> = ({ data }) => {
  if (!data) return null;
  const repShare = Math.max(0, Math.min(100, data.repTalkSharePct ?? 0));
  return (
    <SectionShell title="Talk Balance" valueLabel={`${repShare}% rep`} summary={data.overallSummary}>
      <Box mb={2}>
        <Box display="flex" justifyContent="space-between" mb={0.5}>
          <Typography variant="caption" color="text.secondary">Rep {repShare}%</Typography>
          <Typography variant="caption" color="text.secondary">Customer {100 - repShare}%</Typography>
        </Box>
        <Box sx={{ display: 'flex', height: 8, borderRadius: 1, overflow: 'hidden', bgcolor: 'action.hover' }}>
          <Box sx={{ width: `${repShare}%`, bgcolor: 'primary.main' }} />
        </Box>
      </Box>
      <Stack direction="row" spacing={4} flexWrap="wrap" useFlexGap>
        <Figure label="Interruptions" value={data.repInterruptions} />
        <Figure label="Longest rep turn" value={formatSeconds(data.longestRepMonologueSeconds)} />
        <Figure label="Talking over each other" value={formatSeconds(data.overlapSeconds)} />
      </Stack>
    </SectionShell>
  );
};

export default ConversationalDynamicsSection;
